import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import ReusableImageSelector from "../../media/ReusableImageSelector";
import { API_ENDPOINT } from "../../../utils/constants";
function MediaSelector({ onChange, type }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleSelect = (img) => {
    onChange?.(img);
  };

  return (
    <Box>
      <Button onClick={handleOpen} variant="outlined" size="small">
        Choose {type}
      </Button>
      <ReusableImageSelector
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        onSelect={handleSelect}
        url={`${API_ENDPOINT}/upload/get-all-media?type=${type}`}
      />
    </Box>
  );
}

export default React.memo(MediaSelector);
